/**
 * Shared MUI TextField sx overrides for compact form fields.
 *
 * Mirrors the note-composer rhythm in ExceptionDrawer: 14px body
 * type, 12px input padding, tight helper-text margin. Used by the
 * feedback form fields (FeedbackForm, MyFeedbackList edit) so they
 * stay visually aligned with the rest of the drawer/dialog surfaces.
 */

export const COMPACT_TEXTFIELD_SX = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 1.5,
    fontSize: '0.9rem',
    lineHeight: 1.4,
    // White input fill so fields read as editable even when the
    // surrounding panel/card carries a tinted (grey.50) background.
    backgroundColor: '#FFFFFF',
  },
  '& .MuiOutlinedInput-input': { py: 0.75 },
  '& .MuiInputLabel-root': { fontSize: '0.95rem' },
  '& .MuiFormHelperText-root': {
    mt: 0.5,
    fontSize: '0.68rem',
    lineHeight: 1.3,
  },
} as const
